<template>
  <div class="home">



<!--    <img alt="Vue logo" src="../assets/logo.png">-->
<!--      <div class="mynavbar">-->
<!--        <NavBar/>-->
<!--      </div>-->

<!--      <div class="columns">-->
<!--          <div class="column is-one-fifth mysidemenu">-->
<!--              <SideMenu/>-->
<!--          </div>-->
<!--          <div class="column">-->
<!--              <Demo msg="Hello Demo"/>-->
<!--          </div>-->

<!--      </div>-->

<!--      <SideMenu/>-->
      <Demo msg="Hello Demo"/>
  </div>
</template>

<script>
// import { Component, Vue } from 'vue-property-decorator';
// import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
// import Demo from '@/components/Demo.vue';
// import NavBar from '@/components/NavBar.vue';
// import SideMenu from "@/components/SideMenu.vue";
//
// @Component({
//   components: {
//     NavBar,
//     SideMenu,
//     Demo
//   },
// })
// export default class Home extends Vue {}

import HelloWorld from '@/components/HelloWorld.vue'
import Demo from "../components/Demo";

export default {
    name: 'home',
    components: {
        // HelloWorld,
        Demo
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .is-one-fifth {
        background: #118575;
    }
    .mynavbar {
        background: #118575;
    }
</style>
